/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of all the linked lists available for @see {@link Synqo.Cloud.Model.Api.Permissions.ApiUser}
 */
export class GroupLinkLists {
    /**
     * Represents a list of linked users
     */
    static readonly users: string = 'users';
    /**
     * Represents a list of linked applications
     */
    static readonly external_applications: string = 'applications';
}
